import React, { useRef, useEffect } from "react";
import Navbar from "../components/Navbar";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Data_treatments from "../components/Data-treatments";
import "../pages/styles/treatments.css";
import "../components/styles/buttons.css";
import { Link } from "react-router-dom";
import { TweenMax, Power3 } from "gsap";
import Media from "react-media";
import { Controller, Scene } from "react-scrollmagic";
import {useTranslation, Trans} from 'react-i18next'

function Treatments() {

  const { t } = useTranslation();

  let image = useRef(null);
  let title = useRef(null);

  useEffect(() => {
    TweenMax.to(image, 2, {
      opacity: 1,
      y: -30,
      ease: Power3.easeOut
    });
    TweenMax.to(title, 2, {
      opacity: 1,
      y: -30,
      ease: Power3.easeOut,
      delay: 0.2
    });
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('titleTreatments')}</title>
        <meta name="description" content="Conozca nuestras mordernas instalaciones, donde encontrara el mejor equipo para todos los tratamientos." />
      </Helmet>
      <Navbar />
      <header id="scrollStarts" className="header-tra">
        <div
          ref={selector => {
            title = selector;
          }}
          id="wrapper"
          className="header-info-tra"
        >
          <h1 className="title-tra">{t('treatTitle')}</h1>
          <hr />
          <p className="p-tra">
            {t('treatParaf')}
          </p>
        </div>
        <div className="header-img-tra">
          <img
            ref={selector => {
              image = selector;
            }}
            className="entry"
            src={require("./media/handpiece.svg")}
            alt=""
          />
        </div>
      </header>
      <Controller>
        <div></div>
        <Scene classToggle="fade">
          <section className="treamentsConteiner conteiner tra">
            <h2>
          <Trans>{t('treatSectionParaf1')}</Trans>
            </h2>
            <p>
              {t('treatSectionParaf2')}
            </p>
            <hr />
            <br />
            <div className="boxConteiner">
              <div className=" box treat">
                <img src={require("./media/dental-care.svg")} alt="" />
                <h4>{t('homeSection1Endo')}</h4>
                <hr />
                <p className="textContein">
                  {t('homeSection1EndoParaf')}
                </p>
                <Link className="buttonGreen" to="/endodoncia">
                  {t('seeMoreButton')}
                </Link>
              </div>
              <div className=" box treat">
                <img src={require("../assents-img/stetic.svg")} alt="" />
                <h4>{t('homeSection1Cosm')}</h4>
                <hr />
                <p className="textContein">
                {t('homeSection1CosmParaf')}
                </p>
                <Link className="buttonGreen" to="/estética-dental">
                  {t('seeMoreButton')}
                </Link>
              </div>
              <div className=" box treat">
                <img src={require("../assents-img/braces.svg")} alt="" />
                <h4>{t('homeSection1Orto')}</h4>
                <hr />
                <p className="textContein">
                {t('homeSection1OrtoParaf')} 
                </p>
                <Link className="buttonGreen" to="/ortodoncia">
                  {t('seeMoreButton')}
                </Link>
              </div>
              <div className=" box treat">
                <img src={require("../assents-img/implant.svg")} alt="" />
                <h4>{t('treatSectionImplant')}</h4>
                <hr />
                <p className="textContein">
                    {t('treatSectionImplantDescription')}
                </p>
                <br/>
                <Link className="buttonGreen" to="/implantes-dentales">
                  {t('seeMoreButton')}
                </Link>
              </div>
              <div className=" box treat">
                <img src={require("../assents-img/ciru.svg")} alt="" />
                <h4>{t('treatSectionSugery')}</h4>
                <hr />
                <p className="textContein">
                    {t('treatSectionSugeryDescription')}
                </p>
                <br/>
                <br/>
                <Link className="buttonGreen" to="/cirugía-dental">
                  {t('seeMoreButton')}
                </Link>
              </div>
              <div className=" box treat">
                <img src={require("../assents-img/perio.svg")} alt="" />
                <h4>{t('treatSectionPerio')}</h4>
                <hr />
                <p className="textContein">
                    {t('treatSectionPerioDescription')}
                </p>
                <Link className="buttonGreen" to="/periodoncia">
                  {t('seeMoreButton')}
                </Link>
              </div>
            </div>
          </section>
        </Scene>
      </Controller>
      <Footer />
    </React.Fragment>
  );
}

export default Treatments;
